/*
 This file is part of GNU Taler
 (C) 2022-2024 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */
import { Attention, useTranslationContext } from "@gnu-taler/web-util/browser";
import { Fragment, VNode, h } from "preact";
import { useSessionState } from "../hooks/session.js";
import { useEffect } from "preact/hooks";

export function CallengeCompleted(): VNode {
  const { state } = useSessionState();

  const { i18n } = useTranslationContext();
  
  useEffect(() => {
    window.location.href = state?.completedURL ?? "#"
  },[])

  return (
    <div class="m-4">
      <Attention
        title={i18n.str`Challenge completed`}
        type="success"
      >
        <i18n.Translate>
          You will be redirected to <a href={state?.completedURL} class="break-all">&quot;
          {state?.completedURL}
          &quot;</a>
        </i18n.Translate>
      </Attention>
    </div>
  );
}
